import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { shallowEqual, type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import context from '@alltrails/context/slices/contextSlice';
import { mapReducer } from '@alltrails/maps/redux/reducer';
import { baseApi } from '@alltrails/redux-helpers/baseApi';
import AdvancedMapLayersRootState from './AdvancedMapLayersRootState';
import { advancedMapLayersReducer } from './advancedMapLayersSlice';

export type PreloadedState = Partial<AdvancedMapLayersRootState>;

export const reducer = combineReducers({
  context,
  map: mapReducer,
  advancedMapLayers: advancedMapLayersReducer,
  [baseApi.reducerPath]: baseApi.reducer
});

export const buildStore = (preloadedState?: PreloadedState) =>
  configureStore({
    reducer,
    preloadedState,
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(baseApi.middleware)
  });

export type AppStore = ReturnType<typeof buildStore>;
export type AppDispatch = AppStore['dispatch'];

// these are intended to use within the package only
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<AdvancedMapLayersRootState> = (selector: (state: AdvancedMapLayersRootState) => any) =>
  useSelector<AdvancedMapLayersRootState, any>(selector, shallowEqual);
